"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapFacetFilterFromApi = void 0;
var _tsUtils = require("@ori/ts-utils");
var _getFacetItemFromApi = require("./getFacetItemFromApi");
/**
 * Transforms the facets data from the API into a format suitable for the FacetFilter component.
 *
 * @param facets - The facets data from the API. It's a part of the ProductListingRowsFragment.
 * @returns An array of FacetFilterValues, each representing a facet filter category with its label, key, and items (facets).
 * Each item represents a filter option with its label, selection state, value, and type.
 *
 * Note: Currently, only the default filter option is supported because there is no color filter option in the API.
 * Also, the returned array is sorted by the label of the facet filters in ascending order.
 */ const mapFacetFilterFromApi = (facets)=>{
    var _facets_filter_filter_map;
    return (_facets_filter_filter_map = facets === null || facets === void 0 ? void 0 : facets.filter(_tsUtils.isNonNullable).filter((facet)=>facet.displayName && facet.name).map((facet)=>{
        var _facet_displayName, _facet_name;
        return {
            label: (_facet_displayName = facet.displayName) !== null && _facet_displayName !== void 0 ? _facet_displayName : '',
            key: (_facet_name = facet.name) !== null && _facet_name !== void 0 ? _facet_name : '',
            items: facet.values.map(_getFacetItemFromApi.getFacetItemFromApi)
        };
    })) !== null && _facets_filter_filter_map !== void 0 ? _facets_filter_filter_map : [];
};
exports.mapFacetFilterFromApi = mapFacetFilterFromApi;
